import React, { FC, useMemo } from 'react';
import { FundPerformance } from '../../../../../domain/Storebrand';
import Card from '../../../../../common/Card/Card';
import { formatAmount } from '../../../../../common/util/Functions';

type SavingProfileFundPerformanceProps = {
    fundPerformance: FundPerformance;
};
const SavingProfileFundPerformance: FC<SavingProfileFundPerformanceProps> = ({ fundPerformance }) => {
    const periodData = useMemo(
        () =>
            [
                { key: 'sinceStart', label: 'Siden start', amount: fundPerformance.sinceStart },
                { key: 'yearToDate', label: 'Hittil i år', amount: fundPerformance.yearToDate },
                { key: 'last12Months', label: 'Siste 12 mnd', amount: fundPerformance.last12Months },
                { key: 'last36Months', label: 'Siste 3 år*', amount: fundPerformance.last36Months },
                { key: 'last60Months', label: 'Siste 5 år*', amount: fundPerformance.last60Months },
                { key: 'last120Months', label: 'Siste 10 år*', amount: fundPerformance.last120Months },
            ].filter((dataItem) => !!dataItem.amount),
        [fundPerformance]
    );

    const showUnderText = useMemo(
        () => periodData.some((dataItem) => ['last36Months', 'last60Months', 'last120Months'].includes(dataItem.key)),
        [periodData]
    );
    return (
        <div>
            {fundPerformance && (
                <>
                    {periodData.map(({ key, label, amount }) => (
                        <Card
                            key={key}
                            data={{
                                textList: [
                                    [
                                        {
                                            text: label,
                                            type: 'font-normal',
                                        },
                                        {
                                            text: amount ? `${formatAmount(amount, true)} %` : '—',
                                        },
                                    ],
                                ],
                            }}
                            type="list-item"
                        />
                    ))}
                    {showUnderText && <article className="top-spaced">*Gjennomsnittlig årlig avkastning</article>}
                </>
            )}
        </div>
    );
};

export default SavingProfileFundPerformance;
